import { Box, ListItem, styled, Typography } from "@mui/material";

export const StyledListItem = styled(ListItem)(() => ({
    paddingTop: '14px',
    paddingBottom: '14px',
    paddingLeft: '0',
    paddingRight: '0',
    '& .MuiListItemSecondaryAction-root': {
        right: '2px',
    },
}));

export const StyledListBox = styled(Box)(() => ({
    paddingTop: '14px',
    paddingBottom: '14px',
    paddingLeft: '0',
    paddingRight: '0',
    '& .MuiListItemSecondaryAction-root': {
        right: '2px',
    },
}));

export const StyledEmptyTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    color: theme.palette.secondary.main,
}));

export const emptyGridStyles = {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
        marginLeft: '10px',
        fontSize: '18px',
    }
};

